const pad2 = (value) => String(value).padStart(2, "0");

const normalizeYear = (value) => {
  const text = String(value || "").trim();
  if (!text) return null;
  if (text.length === 2) {
    const year = Number(text);
    if (Number.isNaN(year)) return null;
    return year + 2000;
  }
  const year = Number(text);
  return Number.isNaN(year) ? null : year;
};

export const parseDateParts = (value) => {
  if (!value) return null;
  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) return null;
    return { y: value.getFullYear(), m: value.getMonth() + 1, d: value.getDate() };
  }
  if (typeof value === "number") {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return null;
    return { y: date.getFullYear(), m: date.getMonth() + 1, d: date.getDate() };
  }
  if (value?.toDate) {
    const date = value.toDate();
    if (Number.isNaN(date.getTime())) return null;
    return { y: date.getFullYear(), m: date.getMonth() + 1, d: date.getDate() };
  }
  if (value?.seconds) {
    const date = new Date(value.seconds * 1000);
    if (Number.isNaN(date.getTime())) return null;
    return { y: date.getFullYear(), m: date.getMonth() + 1, d: date.getDate() };
  }

  const text = String(value).trim();
  if (!text) return null;

  if (text.includes("T") || text.includes("Z")) {
    const date = new Date(text);
    if (!Number.isNaN(date.getTime())) {
      return { y: date.getFullYear(), m: date.getMonth() + 1, d: date.getDate() };
    }
  }

  const sep = text.includes("/") ? "/" : text.includes(".") ? "." : text.includes("-") ? "-" : null;
  if (!sep) return null;
  const parts = text.split(sep).map((p) => p.trim());
  if (parts.length !== 3) return null;

  let y;
  let m;
  let d;

  if (sep === "-" && parts[0].length === 4) {
    [y, m, d] = parts;
  } else if (parts[2].length === 4) {
    [d, m, y] = parts;
  } else if (parts[0].length === 4) {
    [y, m, d] = parts;
  } else {
    [d, m, y] = parts;
  }

  const year = normalizeYear(y);
  const month = Number(m);
  const day = Number(d);
  if (!year || Number.isNaN(month) || Number.isNaN(day)) return null;
  if (month < 1 || month > 12 || day < 1 || day > 31) return null;

  return { y: year, m: month, d: day };
};

export const toIsoDate = (value) => {
  const parts = parseDateParts(value);
  if (!parts) return "";
  return `${parts.y}-${pad2(parts.m)}-${pad2(parts.d)}`;
};

export const toStorageDate = (value) => {
  const parts = parseDateParts(value);
  if (!parts) return "";
  return `${pad2(parts.d)}/${pad2(parts.m)}/${parts.y}`;
};

export const toDisplayDate = (value, fallback = "-") => {
  const parts = parseDateParts(value);
  if (!parts) {
    if (value == null || value === "") return fallback;
    return String(value);
  }
  return `${pad2(parts.d)}/${pad2(parts.m)}/${parts.y}`;
};

export const toInputDate = (value) => {
  const parts = parseDateParts(value);
  if (!parts) return "";
  return `${parts.y}-${pad2(parts.m)}-${pad2(parts.d)}`;
};

export const toDateNumber = (value) => {
  const parts = parseDateParts(value);
  if (!parts) return null;
  return new Date(parts.y, parts.m - 1, parts.d).getTime();
};
